import httpClient from "@/services/HttpService";

export default {

    items: () => {
        return httpClient.get('/paese/all');
    }

}